import styled from 'styled-components';
import Title from 'js/components/core/Title';
import { blueColor, darkGreyColor, mediumGreyColor } from 'js/config/style';

export default styled.span`
  line-height: 1rem;
  font-size: 0.8rem;
  padding: 2px 6px;
  background-color: ${blueColor};
  color: white;
  width: max-content;
  border-radius: 4px;
`;
